





























































































































































import {
  IEmployeeFormFieldSubmissionData,
  IEmployeeFormSubmission,
  IFormTemplate,
  EmployeeFormSubmissionStateEnum,
  EmployeeFormSubmission,
  IFormSectionFieldData,
  IFormFieldData
} from '@/models';
import { classToHex, colors } from '@/utils/colorUtils';
import { PropType } from 'vue';

import ConfirmationDialog from '../common/ConfirmationDialog.vue';
import EmployeeFormSubmissionDialog from './EmployeeFormSubmissionDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

import moment from 'moment';
import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';

import SnackBarMixin from '@/mixins/snackbar';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { IUpdateEmployeeFormSubmissionStatePayload } from '@/services';

const baseMixins = mixins(SnackBarMixin, auth);

interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $refs: {
    employeeFormSubmissionDialog: InstanceType<
      typeof EmployeeFormSubmissionDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    components: {
      EmployeeFormSubmissionDialog,
      ErrorAlert,
      ConfirmationDialog
    },

    props: {
      submission: {
        type: Object as PropType<IEmployeeFormSubmission>
      },
      loading: {
        type: Boolean
      },
      canCancel: {
        type: Boolean
      },
      canEdit: {
        type: Boolean
      },
      isOwner: Boolean,
      template: Object as PropType<IFormTemplate>
    },

    data() {
      return {
        EmployeeFormSubmissionStateEnum,
        errorMessage: '',
        errorMessageDetail: '',
        overtimeComment: '',
        commentsDialog: false,

        actionLabel: ''
      };
    },

    computed: {
      internalLoading: {
        get() {
          return this.loading;
        },
        set(value: boolean) {
          this.$emit('update:loading', value);
        }
      },

      getStatusHexColor(): string {
        return classToHex(
          this.submission.getStateInfo().color,
          colors,
          this.$vuetify.theme.currentTheme
        );
      },

      canCompleteValidation(): boolean {
        return (
          this.userHasRoles('IT Admin') &&
          this.submission.state == EmployeeFormSubmissionStateEnum.InReview
        );
      },

      canSubmit(): boolean {
        let submit =
          this.submission.state == EmployeeFormSubmissionStateEnum.Draft &&
          this.isOwner;

        if (submit) {
          for (const answer of this.submission.answers!) {
            const isAnswered =
              (answer.field as IFormSectionFieldData).required &&
              !(answer.value || answer.option_submissions.length > 0);

            if (isAnswered) {
              submit = false;
              break;
            }
          }
        }

        return submit;
      }
    },

    methods: {
      moment,

      ...mapActions({
        updateEmployeeFormSubmissionState:
          'employeeForm/updateEmployeeFormSubmissionState'
      }),

      openFormDialog() {
        this.$refs.employeeFormSubmissionDialog.open(
          this.template as IFormTemplate,
          this.submission
        );
      },

      openCommentDialog() {
        this.overtimeComment = ''; //clears comment dialog on open
        this.commentsDialog = true;
        this.actionLabel =
          EmployeeFormSubmissionStateEnum[
            EmployeeFormSubmissionStateEnum.Cancelled
          ];
      },

      closeCommentsDialog() {
        this.clearAllErrors();
        this.commentsDialog = false;
      },

      getEmployeeFormSubmissionValueByMetaLabel(
        meta_label: string
      ): string | undefined {
        const formFieldSubmission = (this.submission
          .answers as IEmployeeFormFieldSubmissionData[]).find(
          form =>
            ((form.field as IFormSectionFieldData)
              .field_template as IFormFieldData).meta_label === meta_label
        );

        if (!formFieldSubmission) {
          return;
        }

        return formFieldSubmission.value;
      },

      clearAllErrors() {
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      async updateFormState(state: EmployeeFormSubmissionStateEnum) {
        this.internalLoading = true;
        this.clearAllErrors();

        const payload = {
          id: this.submission.id,
          state: state,
          comment: this.overtimeComment
        } as IUpdateEmployeeFormSubmissionStatePayload;

        return this.updateEmployeeFormSubmissionState(payload)
          .then(() => {
            const stateInfo = new EmployeeFormSubmission({
              ...this.submission,
              state: state
            }).getStateInfo();

            this.createSnack({
              color: `${stateInfo.color} darken-1`,
              type: `${stateInfo.color}`,
              right: true,
              useBtn: false,
              msg: `Form Submission ${stateInfo.display_name}`,
              btnText: 'Ok'
            });
            this.closeCommentsDialog();
            this.$emit('refreshComments');
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.internalLoading = false;
          });
      },

      refreshChecklist() {
        this.$emit('refreshChecklist');
      }
    }
  });
